import { FC, ReactElement } from "react";
import { AttachmentsModal } from "./attachmentsModal";

interface AttachmentsPaneProps {
    height: string
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    allowModifications: boolean;
    meetingId?: string;
    itemId?: string;
    sessionId?: string;
    taskId?: string;
    onClose?: () => Promise<void> | void;
    onAttachmentsCountChanged?: (count: number, meetingId?: string, itemId?: string, sessionId?: string, taskId?: string) => Promise<void> | void;
    uploadPrefix?: string;
    contextDisplayName?: string;
}

/**
 * @deprecated Use AttachmentsModal directly instead
 * This component is kept for backward compatibility
 */
export const AttachmentsPane: FC<AttachmentsPaneProps> = (props: AttachmentsPaneProps): ReactElement => {
    return (
        <AttachmentsModal
            open={true}
            height={props.height}
            allowModifications={props.allowModifications}
            meetingId={props.meetingId}
            itemId={props.itemId}
            sessionId={props.sessionId}
            taskId={props.taskId}
            onClose={props.onClose}
            onAttachmentsCountChanged={props.onAttachmentsCountChanged}
            uploadPrefix={props.uploadPrefix}
            contextDisplayName={props.contextDisplayName}
        />
    );
}